const F = {
  open: "Opens after winter closure — typically late April/early May, closing around Diwali. Opening dates change every year; confirm before travel.",
  summer: "Pleasant in summer; carries warm layers even then. Winter visits need cold-weather planning.",
  monsoon: "Landslides and rain can affect roads during monsoon; check conditions just before you travel.",
  allYear: "Reachable through most of the year, but road and weather conditions vary by season — always recheck before departure.",
  voF: "Valley of Flowers is open only for a limited summer–autumn window each year; confirm exact dates with the forest department.",
  winter: "Snow can block access in winter; the best window is usually the warmer months. Confirm local conditions.",
};

export default F;
